export const MOVIE = 'movie'
export const AD = 'ad'
export const ADVERTISEMENT = 'advertisement'
export const HIGHLIGHT = 'highlight'
export const WEISCHER = 'weischer'
export const TITLE = 'title'
export const TEXT = 'text'
export const IMAGE = 'image'
export const GRID_IMAGE = 'gridImage'
export const MOVIE_PERFORMANCES ='moviePerformances'
export const METRO = 'metro'
export const CHOOSENMOVIES = 'choosenMovies'
export const BOTTOMITEMS = 'bottomItems'
export const CUSTOMITEMS = 'customItems'
export const MENUITEM = 'menuItem'
export const NEWSLETTER_TEXT = 'text'
export const NEWSLETTER_IMAGE = 'image'
export const NEWSLETTER_SOCIAL_MEDIA = 'social_media'
export const PUSH_LINK = 'push_link'
